"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Text as t } from "../Text/Text.mjs";
import n, { isValidElement as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { Close as o } from "@videoblocks/react-icons";
import * as s from "@radix-ui/react-dialog";
//#region src/components/atoms/Dialog/Dialog.tsx
var c = ({ ...e }) => /* @__PURE__ */ i(s.Root, {
	"data-slot": "dialog",
	...e
}), l = ({ ...e }) => /* @__PURE__ */ i(s.Trigger, {
	"data-slot": "dialog-trigger",
	...e
}), u = ({ ...e }) => /* @__PURE__ */ i(s.Portal, {
	"data-slot": "dialog-portal",
	...e
}), d = ({ ...e }) => /* @__PURE__ */ i(s.Close, {
	"data-slot": "dialog-close",
	...e
}), f = n.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i(s.Overlay, {
	"data-slot": "dialog-overlay",
	className: e("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/60", t),
	...n,
	ref: r
}));
f.displayName = "DialogOverlay";
var p = ({ className: t, children: n, showCloseButton: r = !0, ...c }) => /* @__PURE__ */ a(u, {
	"data-slot": "dialog-portal",
	children: [/* @__PURE__ */ i(f, {}), /* @__PURE__ */ a(s.Content, {
		"data-slot": "dialog-content",
		className: e("bg-background", "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "fixed top-[50%] left-[50%] z-50", "grid w-full max-w-[calc(100%-2rem)]", "translate-x-[-50%] translate-y-[-50%] gap-4", "rounded-sm border p-6 shadow-lg", "duration-200 md:max-w-lg", t),
		...c,
		children: [n, r && /* @__PURE__ */ a(d, {
			"data-slot": "dialog-close",
			className: "ring-offset-background focus:ring-ring\n                    data-[state=open]:bg-accent data-[state=open]:text-muted-foreground\n                    absolute top-8 right-4 rounded-xs\n                    opacity-70 transition-opacity hover:opacity-100\n                    focus:ring-2 focus:ring-offset-2 focus:outline-hidden\n                    disabled:pointer-events-none [&_svg]:pointer-events-none\n                    [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
			children: [/* @__PURE__ */ i(o, { className: "w-4 h-4 fill-current" }), /* @__PURE__ */ i("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})]
}), m = ({ className: t, ...n }) => /* @__PURE__ */ i("div", {
	"data-slot": "dialog-header",
	className: e("flex flex-col gap-0.5 text-center sm:text-left", t),
	...n
}), h = ({ className: t, ...n }) => /* @__PURE__ */ i("div", {
	"data-slot": "dialog-footer",
	className: e("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", t),
	...n
}), g = ({ className: e, children: n, fontSize: a = "lg", fontWeight: o = "semibold", fontFamily: c = "inter", ...l }) => /* @__PURE__ */ i(s.Title, {
	"data-slot": "dialog-title",
	className: e,
	...l,
	children: /* @__PURE__ */ i(t, {
		asChild: !0,
		fontSize: a,
		fontWeight: o,
		fontFamily: c,
		children: r(n) ? n : /* @__PURE__ */ i("span", { children: n })
	})
}), _ = ({ className: n, children: a, fontSize: o = "sm", fontWeight: c = "regular", fontFamily: l = "inter", ...u }) => /* @__PURE__ */ i(s.Description, {
	"data-slot": "dialog-description",
	className: e("text-muted-foreground", n),
	...u,
	children: /* @__PURE__ */ i(t, {
		asChild: !0,
		fontSize: o,
		fontWeight: c,
		fontFamily: l,
		children: r(a) ? a : /* @__PURE__ */ i("span", { children: a })
	})
});
//#endregion
export { c as Dialog, d as DialogClose, p as DialogContent, _ as DialogDescription, h as DialogFooter, m as DialogHeader, f as DialogOverlay, u as DialogPortal, g as DialogTitle, l as DialogTrigger };
